// STICKY HEADER




// MENU HOVER FUNCTIONALITY

function addMenuHoverFunctionality() {
    // Only apply on screens > 768px
    if (window.innerWidth > 768) {
        const menuContainers = document.querySelectorAll('.x-menu--level-1--container');
        const headerRoot = document.querySelector('.header--root');
        const body = document.querySelector('body');

        if (headerRoot && menuContainers.length > 0) {
            menuContainers.forEach(container => {
                container.addEventListener('mouseenter', function() {
                    headerRoot.classList.add('menu-open');
                    body.classList.add('menu-overlay-active');
                });

                container.addEventListener('mouseleave', function() {
                    headerRoot.classList.remove('menu-open');
                    body.classList.remove('menu-overlay-active');
                });
            });
        }
    }
}

// Initialize on load
document.addEventListener('DOMContentLoaded', addMenuHoverFunctionality);

// Fallback initialization methods
if (document.readyState !== 'loading') {
    addMenuHoverFunctionality();
}

setTimeout(addMenuHoverFunctionality, 1000);
window.addEventListener('load', addMenuHoverFunctionality);

// Re-initialize on window resize to handle screen size changes
let menuResizeTimer;
window.addEventListener('resize', function() {
    clearTimeout(menuResizeTimer);
    menuResizeTimer = setTimeout(function() {
        const menuContainers = document.querySelectorAll('.x-menu--level-1--container');
        const headerRoot = document.querySelector('.header--root');
        const body = document.querySelector('body');
        
        if (headerRoot) {
            headerRoot.classList.remove('menu-open');
            body.classList.remove('menu-open');
        }
        
        addMenuHoverFunctionality();
    }, 250);
});

// Custom drawer toggle functionality 

function enhanceDrawerToggle() {
  const hamburgerButton = document.querySelector('.header--drawer-toggle');
  
  if (!hamburgerButton) {
    return;
  }
  
  // Remove existing listeners by cloning
  const newButton = hamburgerButton.cloneNode(true);
  hamburgerButton.parentNode.replaceChild(newButton, hamburgerButton);
  
  newButton.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    // Check current drawer state using DOM attributes
    const viewport = document.querySelector('.layout--viewport');
    const currentDrawerStatus = viewport?.getAttribute('data-drawer-status');
    const currentSide = viewport?.getAttribute('data-drawer-side');
    
    // Check if left drawer is currently open
    const isLeftDrawerOpen = currentDrawerStatus === 'opened' && currentSide === 'left';
    
    if (isLeftDrawerOpen) {
      // Use existing close button logic - trigger click on close button
      const closeButton = document.querySelector('.layout--navigation > .layout--close');
      if (closeButton) {
        closeButton.click();
      }
    } else {
      // Open drawer using existing data attributes (original functionality)
      window.trigger('theme:drawer:open', {
        side: 'left',
        view: 'y-menu',
        trigger: this
      });
    }
  });
}

function enhanceSearchToggle() {
  const searchButton = document.querySelector('.header--search');
  
  if (!searchButton) {
    return;
  }
  
  // Remove existing listeners by cloning
  const newButton = searchButton.cloneNode(true);
  searchButton.parentNode.replaceChild(newButton, searchButton);
  
  newButton.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    // Check current drawer state using DOM attributes
    const viewport = document.querySelector('.layout--viewport');
    const currentDrawerStatus = viewport?.getAttribute('data-drawer-status');
    const currentSide = viewport?.getAttribute('data-drawer-side');
    
    // Check if top drawer (search) is currently open
    const isTopDrawerOpen = currentDrawerStatus === 'opened' && currentSide === 'top';
    
    if (isTopDrawerOpen) {
      // Use existing cancel button logic - trigger click on cancel button
      const cancelButton = document.querySelector('.search--cancel');
      if (cancelButton) {
        cancelButton.click();
      }
    } else {
      // Open drawer using existing data attributes (original functionality)
      window.trigger('theme:drawer:open', {
        side: 'top',
        view: 'search',
        trigger: this
      });
    }
  });
}

function enhanceMovedCloseButton() {
  const closeButton = document.querySelector('.cart--close');
  
  if (!closeButton) {
    return;
  }
  
  // Remove existing listeners by cloning
  const newButton = closeButton.cloneNode(true);
  closeButton.parentNode.replaceChild(newButton, closeButton);
  
  newButton.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    // Close any open drawer using the theme's event system
    window.trigger('theme:drawer:close');
  });
  
  // Also handle keyboard events (Enter key)
  newButton.addEventListener('keydown', function(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      window.trigger('theme:drawer:close');
    }
  });
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(() => {
    enhanceDrawerToggle();
    enhanceSearchToggle();
    enhanceMovedCloseButton();
  }, 500);
});


document.addEventListener('DOMContentLoaded', function() {
    const refineButton = document.getElementById('refine-button');
    console.log('Refine button found:', refineButton);
    
    if (refineButton) {
        refineButton.addEventListener('click', function(event) {
            console.log('🎯 REFINE BUTTON CLICKED!');
            
            const drawerRoot = document.querySelector('[data-drawer-view="filter"] .drawer--root');
            const navigationSection = document.querySelector('.section--collection-navigation');
            
            console.log('Drawer root:', drawerRoot);
            console.log('Navigation section:', navigationSection);
            
            if (drawerRoot && navigationSection) {
                console.log('✅ Moving element...');
                navigationSection.appendChild(drawerRoot);
            } else {
                console.log('❌ Could not find required elements');
                if (!drawerRoot) console.log('Missing: drawer root');
                if (!navigationSection) console.log('Missing: navigation section');
            }
        });
    } else {
        console.log('❌ Refine button not found');
    }
});

document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.pickup--drawer--list-stock p br').forEach(br => {
        br.replaceWith(' ');
    });
});


document.addEventListener('DOMContentLoaded', function() {



    let searchButtons = document.querySelectorAll('.header--bottom-row--search__button');
    let searchInputs = document.querySelectorAll('.header--bottom-row--search__input');
    if (searchButtons.length > 0 && searchInputs.length > 0) {
        searchButtons.forEach(function(searchButton) {
            let searchInput = searchButton.closest('form').querySelector('.header--bottom-row--search__input');
            searchButton.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                searchInput.classList.toggle('header--bottom-row--search__input--visible');
                searchButton.classList.toggle('header--bottom-row--search__button--hidden');
                return false;
            });
        });
        
        searchInputs.forEach(function(searchInput) {
            searchInput.addEventListener('keydown', function(event) {
                if (event.type === 'keydown' && event.key === 'Enter') {
                    event.preventDefault();
                    event.stopPropagation();
                    searchInput.closest('form').submit();
                    return false;
                }
            });
        });

        document.addEventListener('click', function(e) {
            if (e.target.closest('.header--bottom-row--search__input')) {
                return;
            }
            searchInputs.forEach(function(searchInput) {
                searchInput.classList.remove('header--bottom-row--search__input--visible');
            });
            searchButtons.forEach(function(searchButton) {
                searchButton.classList.remove('header--bottom-row--search__button--hidden');
            });
        });
    }

    let filterButton = document.querySelector('.navigation--button[data-toggle-menu="refine-filter"]');
    let filterMenu = document.querySelector('.off-canvas--container__custom');
    if (!!filterButton && !!filterMenu) {
        filterMenu.style.setProperty('--menu-height', filterMenu.scrollHeight + 'px');
    
        filterButton.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            filterMenu.classList.toggle('off-canvas--container__custom--visible');
            return false;
        });
    
        let filterCategories = document.querySelectorAll('.filter--category');
        filterCategories.forEach(function(filterCategory) {
            let filterCategoryButton = filterCategory.querySelector('.filter--toggle');
            let filterCategoryContent = filterCategory.querySelector('.filter--menu');
            filterCategoryContent.style.setProperty('--menu-height', filterCategoryContent.scrollHeight + 'px');
    
            filterCategoryButton.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                filterCategoryContent.classList.toggle('filter--menu__visible');
                if (filterCategoryContent.classList.contains('filter--menu__visible')) {
                    filterMenu.style.setProperty('--menu-height', filterMenu.scrollHeight + filterCategoryContent.scrollHeight + 'px');
                } else {
                    filterMenu.style.setProperty('--menu-height', filterMenu.scrollHeight - filterCategoryContent.scrollHeight + 'px');
                }
                return false;
            });
        });
    
        document.addEventListener('theme:filters:updated', function(e) {
            let { body_html } = e.detail;
            let filterTags = document.querySelectorAll('.filter--link[data-type="refine"] input');
            filterTags.forEach(function(filterTag) {
                let filterTagValue = filterTag.value;
                let correspondingFilter = body_html.find(`.filter--link[data-type="refine"] input[value="${filterTagValue}"]`).closest('.filter--link').data('count');
                let parentFilter = filterTag.closest('.filter--link');
                if (parentFilter) {
                    parentFilter.dataset.count = correspondingFilter;
                    if (correspondingFilter > 0 || filterTag.checked) {
                        parentFilter.classList.remove('filter--link__disabled');
                    } else {
                        parentFilter.classList.add('filter--link__disabled');
                    }
                }
            });
                
        });;
    
        let realClearButton = document.querySelector('.navigation--active-clear:not(.navigation--active-clear__custom)');
        let clearButton = document.querySelector('.navigation--active-clear__custom');
        if (clearButton) {
            clearButton.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                realClearButton.click();
                window.scrollTo(0, 0);
                return false;
            });
        }
    }

    let customOrderPage = document.querySelector('.order-summary');
    let tableRowPlaceholder = document.querySelector('.order-summary__table-row--placeholder');
    let orderCustomerName = document.querySelector('.order-summary__name');
    let orderTailorName = document.querySelector('.order-summary__tailor-name');
    let orderItemsTable = document.querySelector('.order-summary__table');
    let orderStatus = document.querySelector('.order-summary__status');
    let orderETATitle = document.querySelector('.order-summary__eta-title');
    let orderETA = document.querySelector('.order-summary__eta');
    let mainContent = document.querySelector('.page--custom-order-status');

    const statusTexts = {
        'in-progress': 'Order In Progress',
        'ready': 'Ready to collect',
        'completed': 'Contact Us',
    }


    const initOrderSummary = async (orderId, orderSummaryEl) => {
        let response = await fetch(`https://api.pjt.com/api/ticktock/order/${orderId}`, {
            headers: {
                'Auth-Token': 'D;g?JLgz<O>Wjyt`MF~sPJ8-1w@2M<EU,4d/_QjrZvm$mdyu0OG:{y:5y,*7Mh5A'
            }
        });
        let order = await response.json();
        if (order.errorKey == 'error') {
            mainContent.classList.add('page--custom-order-status--empty');
            return;
        }

        mainContent.classList.remove('page--custom-order-status--empty');
        orderCustomerName.innerHTML = order.data.customerName;
        orderTailorName.innerHTML = order.data.tailorName;
        let tailorImage = document.querySelector(`.order-summary__tailor-image[data-tailor="${order.data.tailorName}"]`);
        if (tailorImage) {
            tailorImage.classList.add('order-summary__tailor-image--visible');
        } else {
            document.querySelector('.order-summary__tailor-image').classList.add('order-summary__tailor-image--visible');
        }

        order.data.orderProducts.forEach(function(orderProduct) {
            let tableRow = tableRowPlaceholder.cloneNode(true);
            let productType = orderProduct.productType.toUpperCase();
            tableRow.classList.remove('order-summary__table-row--placeholder');
            tableRow.querySelector('[data-order]').innerHTML = orderProduct.productNumber;
            tableRow.querySelector('[data-item]').innerHTML = `
                <div class="order-summary__table-row-cell__code">${orderProduct.productNumber}</div>
                ${productType}, ${orderProduct.productFabric}
            `;

            console.log(orderProduct.productStatus);
            tableRow.querySelector('.order-summary__table-row-cell__status').dataset.status = orderProduct.productStatus;
            tableRow.querySelector('.order-summary__table-row-cell__status').setAttribute('data-status', orderProduct.productStatus);
            orderItemsTable.appendChild(tableRow);
            console.log(tableRow, tableRow.querySelector('.order-summary__table-row-cell__status').dataset.status);
        });
        let orderStatusText = statusTexts[order.data.orderStatus];
        orderStatus.innerHTML = orderStatusText;
        
        if (order.data.orderStatus === 'completed') {
            orderStatus.href = '/pages/contact';
        } else {
            orderStatus.removeAttribute('href');
        }
        
        customOrderPage.dataset.state = order.data.orderStatus;

        if (order.data.orderExpectedAt && order.data.orderStatus == 'in-progress') {
            orderETATitle.classList.remove('visually-hidden');
            orderETA.innerHTML = order.data.orderExpectedAt
        } else {
            orderETATitle.classList.add('visually-hidden');
        }

        if (order.data.orderStatus === 'completed') {
            orderStatus.classList.add('order-summary__status--completed');
        }
    }

    if (customOrderPage) {
        let urlParams = new URLSearchParams(window.location.search);
        let orderNumber = urlParams.get('id');  
        initOrderSummary(orderNumber, customOrderPage);
    }
});



// FILTER TABS

document.addEventListener('DOMContentLoaded', function() {
    // Find the filter tabs container specifically
    const filterTabsContainer = document.querySelector('.filter-tabs');
    if (!filterTabsContainer) return;
    
    // Get the parent filter container
    const filterContainer = filterTabsContainer.closest('.filter--root') || 
                           filterTabsContainer.closest('.filter--wrapper');
    if (!filterContainer) return;
    
    // Only select tab elements within this filter container
    const filterTabButtons = filterContainer.querySelectorAll('.filter-tab-button');
    const filterCategories = filterContainer.querySelectorAll('.filter--category');

    // Function to check if we're on mobile
    function isMobile() {
        return window.innerWidth < 768;
    }

    // Function to show/hide filter categories based on active tab
    function showFilterCategory(targetSubtab) {
        // Only apply tab logic on mobile
        if (!isMobile()) {
            // On desktop, show all categories
            filterCategories.forEach(category => {
                category.style.display = 'block';
            });
            return;
        }

        // Hide all filter categories first
        filterCategories.forEach(category => {
            category.style.display = 'none';
        });
        
        // Show the targeted category if it exists
        if (targetSubtab) {
            const targetCategory = filterContainer.querySelector(`#${targetSubtab}`);
            if (targetCategory) {
                targetCategory.style.display = 'block';
            }
        } else {
            // If no subtab specified (like "Sort by"), show the sort category
            const sortCategory = filterContainer.querySelector('#sort_filter');
            if (sortCategory && sortCategory.closest('.filter--category')) {
                sortCategory.closest('.filter--category').style.display = 'block';
            }
        }
    }

    // Add click listeners to filter tab buttons
    filterTabButtons.forEach(button => {
        button.addEventListener('click', function() {
            // Only handle clicks on mobile
            if (!isMobile()) return;
            
            const targetSubtab = this.getAttribute('data-subtab');
            
            // Remove active class from all filter tab buttons
            filterTabButtons.forEach(btn => btn.classList.remove('active'));
            
            // Add active class to clicked button
            this.classList.add('active');
            
            // Show the appropriate filter category
            showFilterCategory(targetSubtab);
        });
    });

    // Function to initialize the filter display
    function initializeFilters() {
        if (isMobile()) {
            // Initialize - show the first category by default on mobile
            if (filterTabButtons.length > 0) {
                const firstButton = filterTabButtons[0];
                firstButton.classList.add('active');
                const firstSubtab = firstButton.getAttribute('data-subtab');
                showFilterCategory(firstSubtab);
            }
        } else {
            // On desktop, show all categories and remove active states
            filterTabButtons.forEach(btn => btn.classList.remove('active'));
            showFilterCategory(); // This will show all categories on desktop
        }
    }

    // Initialize on page load
    initializeFilters();

    // Handle window resize
    window.addEventListener('resize', function() {
        initializeFilters();
    });
});







// MARKET SELECTOR



document.addEventListener('DOMContentLoaded', function() {
  const marketSelects = document.querySelectorAll('.market-select');
  
  marketSelects.forEach(function(marketSelect) {
    marketSelect.addEventListener('change', function() {
      const selectedUrl = this.value;
      if (selectedUrl) {
        window.location.href = selectedUrl;
      }
    });
  });
});

// COLLECTION FILTERS

const refineFilterButton = document.getElementById('refine-filter-button');
const mainCollectionFilters = document.querySelector('.main--collection-filters');
const applyFilterButton = document.querySelector('.filter--button[data-type="apply"]');

if (refineFilterButton && mainCollectionFilters) {
    refineFilterButton.addEventListener('click', function() {
        mainCollectionFilters.classList.toggle('on');
        this.classList.toggle('active');
    });
}

// Close filters when clicking apply button
if (applyFilterButton && mainCollectionFilters && refineFilterButton) {
    applyFilterButton.addEventListener('click', function() {
        mainCollectionFilters.classList.remove('on');
        refineFilterButton.classList.remove('active');
    });
}

// SIZING LIGHTBOX

function openLightbox(imgElement) {
  const lightbox = document.getElementById('lightbox');
  const lightboxImg = document.getElementById('lightbox-img');
  
  lightboxImg.src = imgElement.src;
  lightboxImg.alt = imgElement.alt;
  lightbox.classList.add('active');
  
  document.body.style.overflow = 'hidden';
}

function closeLightbox() {
  const lightbox = document.getElementById('lightbox');
  lightbox.classList.remove('active');
  document.body.style.overflow = '';
}

document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    closeLightbox();
  }
});

// Replace the last event listener with:
document.querySelector('.lightbox-content').addEventListener('click', function(e) {
  e.stopPropagation();
});


// Watch for changes on the source element
const sourceElement = document.querySelector('.header--root .header--cart');
const targetElement = document.querySelector('.cart--header .header--cart');

if (sourceElement && targetElement) {
  // Create observer to watch for attribute changes
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'data-cart-count') {
        const newValue = sourceElement.getAttribute('data-cart-count');
        targetElement.setAttribute('data-cart-count', newValue);
      }
    });
  });

  // Start observing
  observer.observe(sourceElement, {
    attributes: true,
    attributeFilter: ['data-cart-count']
  });

  // Sync initial value
  const initialValue = sourceElement.getAttribute('data-cart-count');
  if (initialValue !== null) {
    targetElement.setAttribute('data-cart-count', initialValue);
  }
}